import { Injectable, Pipe } from '@angular/core';

@Injectable()
    @Pipe({
        name: 'phone'
    })
export class PhonePipe {
    transform(val) {
        if (val) {
            var viewVal = val.trim().replace(/^\+/, '');
            viewVal = viewVal.replace(/[^0-9]/g, '').slice(0, 10);
            var area, number;

            switch (viewVal.length) {
                case 1:
                case 2:
                case 3:
                    area = viewVal;
                    break;
                default:
                    area = viewVal.slice(0, 3);
                    number = viewVal.slice(3);
            }

            if (number) {
                if (number.length > 3) {
                    number = number.slice(0, 3) + '-' + number.slice(3, 7);
                }
                else {
                    number = number;
                }
                return (area + "-" + number).trim().slice(0, 13);
            }
            else {
                return area;
            }
        }
    }
}

@Injectable()
    @Pipe({
        name: 'extension'
    })
export class ExtensionPipe {
    transform(val) {

        var viewVal = val.trim().replace(/^\+/, '');
        viewVal = viewVal.replace(/[^0-9]/g, '').slice(0, 10);
        var ext;

        switch (viewVal.length) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                ext = viewVal;
                break;
            default:
                ext = viewVal.slice(0, 5);
        }

        return ext;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/pipes/phone.pipe.ts